import { render, staticRenderFns } from "./PurchaseGift.vue?vue&type=template&id=6acceb2a&scoped=true&"
import script from "./PurchaseGift.vue?vue&type=script&lang=js&"
export * from "./PurchaseGift.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseGift.vue?vue&type=style&index=0&id=6acceb2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6acceb2a",
  null
  
)

export default component.exports